<template>
  <div>
    <query-form
      :data="formData"
      @query="query"
      @reset="reset"
      :list="dataList"
      :sendParams="sendParams"
    ></query-form>
    <table-list
      :data="dataList"
      @query="query"
      ref="tableList"
      :sendParams="sendParams"
    />
    <v-row justify="end">
      <v-col cols="auto">
        <v-pagination
          v-if="totalPage > 0"
          v-model="formData.pageNum"
          :length="totalPage"
          :total-visible="totalVisible"
          @input="query"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { asgLtcSampleList, asgLtcSampleGetSendInfoAPI } from "@/plugins/api";
import queryForm from "./queryForm.vue";
import tableList from "./tableList.vue";

export default {
  data() {
    return {
      dataList: [],
      formData: {
        status: "-1", //    状态值查询
        projectNo: "", //     项目方案号
        contractNo: "", //     合同编号
        pageSize: 10,
        pageNum: 1,
      },
      totalPage: 0, //最大页数
      totalVisible: 10, //最大可见页数
      sendParams: {}, //寄送参数
    };
  },
  created() {
    this.init();
  },
  components: { queryForm, tableList },
  methods: {
    async init() {
      this.$store.commit("showLoading");
      this.asgLtcSampleGetSendInfo();
      await this.onQueryProject(this.Utility.transForm(this.formData));
    },
    async onQueryProject(params) {
      await asgLtcSampleList(params)
        .then((res) => {
          const projects = res.data?.samples || [];
          if (projects.length > 0) {
            projects.map((item) => (item.isChecked = false));
          }
          this.dataList = projects;
          this.$refs.tableList.resetSelectAll();
          this.totalPage = res.data?.totalPage;
        })
        .finally(() => {
          this.$store.commit("hideLoading");
        });
    },
    reset() {
      this.formData = Object.assign({}, this.formData, {
        status: "-1", //    状态值查询
        projectNo: "", //     项目方案号
        contractNo: "", //     合同编号
        pageSize: 10,
        pageNum: 1,
      });
      this.onQueryProject(this.Utility.transForm(this.formData));
    },
    query() {
      this.onQueryProject(this.Utility.transForm(this.formData));
      this.asgLtcSampleGetSendInfo()
    },
    // 获取回收信息
    asgLtcSampleGetSendInfo() {
      asgLtcSampleGetSendInfoAPI().then(({ data }) => {
        this.sendParams = data;
      });
    },
  },
};
</script>
